import {basicContext} from "../../../utils/contextUtils";
import _ from "lodash";
import async from "async";
const Errors = require("../../../utils/Errors").default

export const entity = {
    name: 'MinMaxAmount',
    fields: [
        {path: 'code', unique: true},
        {path: 'min', type: 'integer'},
        {path: 'max', type: 'integer'}
    ],
    filters: [
        {
            name: "byAmount",
            isDefault: false,
            query: function(context) {
                const amount = _.get(context.data, 'amount')
                return amount ?
                    {"min": {$lte:parseFloat(amount)}, "max": {$gte:parseFloat(amount)}} : {_id: "0"}
            }
        }
    ],
    uniqueProcess: function (minMaxID, _min, _max, context, callback) {
        if (_min>=_max) return callback(new Errors.ValidationError(context.tc('maxGreaterThanMinError')))

        async.parallel([
            callback => global.app.SE.MinMaxAmount.find({
                ...basicContext(context),
                fieldPath: ['role.id'],
                query: {}
                },(e, objects) => {callback(e, !objects.length)}
            ),
            callback => global.app.SE.MinMaxAmount.find({
                ...basicContext(context),
                fieldPath: ['role.id'],
                query: {
                    _id: {$ne: new global.ObjectID(minMaxID)},
                    $or: [{"min": {$lte:_max}, "max": {$gte:_min}}, {"max": {$eq:_min}}]
                }}, callback
            ),
        ],(error, results) => {
            if (error) return callback(error)
            const [isItFirstRange, combinations] = results
            if (isItFirstRange && _min!==0) return callback(new Errors.ValidationError(context.tc('firstMinAmountShouldBe0Error')))
            if (!isItFirstRange && !combinations.length) return callback(new Errors.ValidationError(context.tc('discontinuousRangesError')))
            if (!isItFirstRange && (combinations.length > 1 || combinations[0]?.max !== _min) ) return callback(new Errors.ValidationError(context.tc('rangesOverlapError')))

            callback()
        })
    },
    validateSave: function (newObject, oldObject, context, callback) {
        this.uniqueProcess(newObject.id, newObject.min, newObject.max, context, callback)
    }
}

export const module_ = {
    object: 'MinMaxAmount',
    category: {
        path: 'process',
        icon: 'repeat'
    },
    tKey: 'financialBracket',
    defaultSortBy: 'code',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            'code',
            {path: 'min', tKey: 'min. (k)'},
            {path: 'max', tKey: 'max. (k)'},
        ],
        form: [
            {
                path: 'code',
                disabled: true,
                editable: false,
                required: true,
                default: 'Min. (k) < Plage (k) ≤ Max. (k)'
            },
            {
                path: 'min',
                tKey: 'min. (k)',
                default: 0,
                editable: false,
                wholePositiveNumber: true,
                required: true,
                subscriptions: {
                    onChange: (newValue, oldValue, {module}) => {
                        const codeField = module.viewMap.form.fields.find( field => field.path === 'code')
                        const maxField = module.viewMap.form.fields.find( field => field.path === 'max')
                        const max = maxField.getValue() ?? 'Max.'
                        const min = newValue ?? 'Min.'
                        codeField.setValue(`${min} (k) < Plage (k) ≤ ${max} (k)`)
                    }
                }
            },
            {
                path: 'max',
                tKey: 'max. (k)',
                default: 0,
                editable: false,
                wholePositiveNumber: true,
                required: true,
                subscriptions: {
                    onChange: (newValue, oldValue, {module, store}) => {
                        const codeField = module.viewMap.form.fields.find( field => field.path === 'code')
                        const minField = module.viewMap.form.fields.find( field => field.path === 'min')
                        const min = minField.getValue() ?? 'Min.'
                        const max = newValue ?? 'Max.'
                        codeField.setValue(`${min} (k) < Plage (k) ≤ ${max} (k)`)
                    }
                }
            }
        ],
    }
}